module.exports = __webpack_public_path__ + "img/kardex.fa6df477.svg";